import { Grid, Stack } from '@mui/material';

import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import ButtonComp from 'common/components/Button/ButtonComp';
import {
	StyledLinedTabs,
	StyledLinedTab,
} from 'common/components/TabBar/TabBarList';
import { setUserManagementSelectedTab } from 'common/store/reducer/userManagementReducer';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { RootState } from '../../../common/store/AppStore';
import { setPagination } from '../../../common/store/reducer/commonReducer';
import {
	setAllUsersList,
	setActiveUsers,
	setInActiveUsers,
	setSelectedTab,
} from '../../../common/store/reducer/UserManagementListReducer';

import CreateUser from './AddUser/CreateUser';
import UsersSelectionToolbar from './UsersSelectionToolbar';

import styles from './UserManagement.module.scss';

interface IUserManagementToolbarProps {
	onUserAction: () => void;
}

const UserManagementToolbar = (props: IUserManagementToolbarProps) => {
	const { onUserAction } = props;
	const selectedTab = useSelector(
		(state: RootState) => state.usersmanagement.selectedTab,
	);
	const [selectedIndex, setSelectedIndex] = useState(selectedTab);
	const [modal, setModal] = useState<boolean>(false);
	const dispatch = useDispatch();
	const isUserListChecked = useSelector(
		(state: RootState) => state.common.isUserListChecked,
	);
	const allUsers = useSelector(
		(state: RootState) => state.usersListmgmt.allUsersList,
	);

	const activeUsers = useSelector(
		(state: RootState) => state.usersListmgmt.activeUsers,
	);

	const inActiveUsers = useSelector(
		(state: RootState) => state.usersListmgmt.inActiveusers,
	);
	const paginationRowsModel = useSelector(
		(state: RootState) => state.common.rowsPerPage,
	);
	const onAddUser = useCallback(() => {
		setModal(true);
	}, []);
	const onModalClose = () => {
		const paginationObj = {
			pageSize: paginationRowsModel.rowsPerPage,
			pageNumber: 0,
		};

		dispatch(setPagination(paginationObj));
		onUserAction();
		setModal(false);
	};
	const onTabChange = (event: React.SyntheticEvent, id: number) => {
		dispatch(setUserManagementSelectedTab(id));
		dispatch(setSelectedTab(id));
		setSelectedIndex(id);
		const paginationObj = {
			pageSize: paginationRowsModel.rowsPerPage,
			pageNumber: 0,
		};

		dispatch(setPagination(paginationObj));
	};
	useEffect(() => {
		if (selectedIndex === 0) {
			dispatch(setAllUsersList(allUsers));
		} else if (selectedIndex === 1) {
			dispatch(setActiveUsers(allUsers));
		} else if (selectedIndex === 2) {
			dispatch(setInActiveUsers(allUsers));
		}
	}, [selectedIndex, allUsers]);

	return !isUserListChecked ? (
		<Grid container data-testid="usermanagement-toolbar">
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={12}
				className={styles['toolbar-grid-container']}
			>
				<Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
					<div className={styles['usermanagement-tabs']}>
						<div className={styles['usermanagement-tabs-block']}>
							<StyledLinedTabs
								data-testid="usermanagement-toolbar-maintab"
								value={selectedIndex}
								onChange={onTabChange}
								aria-label="scrollable prevent tabs example"
							>
								<StyledLinedTab
									data-testid="usermanagement-toolbar-allusers"
									label={`All users(${allUsers.length})`}
								/>
								<StyledLinedTab
									data-testid="usermanagement-toolbar-activeusers"
									label={`Active users(${activeUsers.length})`}
								/>
								<StyledLinedTab
									data-testid="usermanagement-toolbar-inactiveusers"
									label={`Inactive users(${inActiveUsers.length})`}
								/>
							</StyledLinedTabs>
						</div>
					</div>
				</Grid>

				<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
					<Stack
						direction="row"
						alignItems="flex-end"
						justifyContent="flex-end"
						spacing={2}
						className={styles['toolbar-right-stack']}
					>
						<ButtonComp btnType="secondary" size="small">
							{toSentenceCase('Import Users')}
						</ButtonComp>
						<ButtonComp
							btnType="primary"
							size="small"
							clickHandler={onAddUser}
							data-testid="usermanagement-toolbar-addUser"
						>
							{toSentenceCase('Add Users')}
						</ButtonComp>
					</Stack>
				</Grid>
			</Grid>

			{modal ? (
				<div>
					<CreateUser onClose={onModalClose} openModal={modal} />
				</div>
			) : null}
		</Grid>
	) : (
		<div>
			<UsersSelectionToolbar />
		</div>
	);
};

export default UserManagementToolbar;
